<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="detalhe-header mb-4">
      <div class="produto-info">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Ordem de Produção</h1>
            <p class="welcome-message">
              <span class="header-subtitle">
                <button mat-icon-button (click)="voltar()" aria-label="Voltar">
                  <mat-icon>arrow_back</mat-icon>
                </button>
                @if (ordem) {
                <span class="status-badge badge-dot"
                  [ngClass]="statusOrdemProducaoBadge[ordem.idStatusOrdemProducao]">
                  {{ statusOrdemProducaoDescricao[ordem.idStatusOrdemProducao] }}
                </span>
                @if (integracoes.length) {
                <span class="indicador-grid">
                  @for (integracao of integracoes; track integracao.sigla) {
                  <span class="indicador" [style.--indicador-cor]="integracao.cor" [matTooltip]="integracao.rotulo"
                    [attr.aria-label]="integracao.rotulo">{{ integracao.sigla }}</span>
                  }
                </span>
                }
                <span>OP {{ ordem.numero }}</span>
                }
              </span>

            </p>
          </div>
        </div>
      </div>

      <div class="header-actions">
        @if (podeAlterar && ordem && !isTravadaPorEstoque) {
        <button mat-stroked-button class="btn-secondary" [disabled]="_isLoading" (click)="editar()">
          <mat-icon class="material-symbols-outlined">edit</mat-icon> Editar
        </button>
        }
        @if (podeExcluirEstoque && isEstoqueLancado) {
        <button mat-flat-button class="btn-primary" [disabled]="_isLoading" (click)="abrirExcluirEstoque()">
          <mat-icon class="material-symbols-outlined">undo</mat-icon> Excluir estoque
        </button>
        }

        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
          Ações <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #acoesMenu="matMenu">
          @if (podeLancarEstoque) {
          <button mat-menu-item (click)="abrirLancarEstoque()">
            <mat-icon class="material-symbols-outlined">inventory</mat-icon>
            <span>Lançar estoque</span>
          </button>
          }
          @if (podeExcluirEstoque && isEstoqueLancado) {
          <button mat-menu-item (click)="abrirExcluirEstoque()">
            <mat-icon class="material-symbols-outlined">undo</mat-icon>
            <span>Excluir estoque</span>
          </button>
          }
          <button mat-menu-item (click)="imprimirDetalhe()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir detalhe</span>
          </button>
          <button mat-menu-item (click)="imprimirEstrutura()">
            <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
            <span>Imprimir estrutura</span>
          </button>
          @if (podeAlterar) {
          <button mat-menu-item (click)="gerarOrdensRelacionadas()">
            <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
            <span>Gerar ordens relacionadas</span>
          </button>
          <button mat-menu-item (click)="clonar()">
            <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
            <span>Clonar</span>
          </button>
          }
          @if (podeExcluir) {
          <button mat-menu-item (click)="excluir()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            <span>Excluir</span>
          </button>
          }

          @if (podeAlterar && ordem) {
          <mat-divider></mat-divider>
          <div class="menu-alterar-status" (click)="$event.stopPropagation()">
            <div class="menu-alterar-status__label">
              <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
              <span>Alterar status</span>
            </div>
            <div class="menu-alterar-status__dots">
              @for (status of [statusOrdemProducaoEnum.EmAberto, statusOrdemProducaoEnum.EmAndamento,
              statusOrdemProducaoEnum.Finalizada, statusOrdemProducaoEnum.Cancelada]; track status) {
              <span class="bolinha-status-wrapper"
                [matTooltip]="motivoStatusBloqueado(status) ?? statusOrdemProducaoDescricao[status]">
                <button type="button" class="bolinha-status" [class]="'bolinha-' + status"
                  [class.ativa]="ordem.idStatusOrdemProducao === status" [disabled]="!!motivoStatusBloqueado(status)"
                  [attr.aria-label]="statusOrdemProducaoDescricao[status]" (click)="alterarStatus(status)">
                </button>
              </span>
              }
            </div>
          </div>
          }
        </mat-menu>
      </div>
    </div>

    @if (_isLoading && !ordem) {
    <div class="section-container">
      <app-loading-box [height]="'30'" [width]="'220'" [margin]="'0 0 20px 0'"></app-loading-box>
      <div class="row g-3">
        <div class="col-6 col-md-3"><app-loading-box [height]="'48'"></app-loading-box></div>
        <div class="col-6 col-md-3"><app-loading-box [height]="'48'"></app-loading-box></div>
        <div class="col-6 col-md-3"><app-loading-box [height]="'48'"></app-loading-box></div>
        <div class="col-6 col-md-3"><app-loading-box [height]="'48'"></app-loading-box></div>
      </div>
    </div>

    <div class="section-container">
      <app-loading-box [height]="'30'" [width]="'160'" [margin]="'0 0 20px 0'"></app-loading-box>
      <app-loading-box [height]="'180'"></app-loading-box>
    </div>

    <div class="section-container">
      <app-loading-box [height]="'30'" [width]="'220'" [margin]="'0 0 20px 0'"></app-loading-box>
      <app-loading-box [height]="'220'"></app-loading-box>
    </div>
    } @else if (ordem) {

    <!-- ── Banner de edição bloqueada (8.2) ────────────────────────────── -->
    @if (isEstoqueLancado) {
    <div class="section-container">
      <app-alert-card type="warning" title="Edição desabilitada">
        Não é possível editar ordens de produção que possuem estoque lançado.
        @if (podeExcluirEstoque) {
        <a href="javascript:void(0)" (click)="abrirExcluirEstoque()">Exclua o estoque</a> para editar.
        } @else {
        Exclua o estoque para editar.
        }
      </app-alert-card>
    </div>
    }

    <!-- ── Resumo do lançamento de estoque (8.3-bis) ───────────────────── -->
    @if (isEstoqueLancado) {
    <div class="section-container">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
        <span>Resumo do lançamento de estoque</span>
      </div>

      @if (_isLoadingResumoEstoque) {
      <app-loading-box [height]="'120'"></app-loading-box>
      } @else if (resumoEntrada) {
      <div class="row g-3">
        <div class="col-6 col-md-3">
          <small class="d-block">Entrada no estoque</small>
          <span class="text-bold resumo-entrada-valor">
            +{{ resumoEntrada.quantidade | abnt:'quantidade':(ordem.isUnidadeMedidaFracionada ? undefined : 0) }} {{
            resumoEntrada.unidade }}
          </span>
          <span class="d-block text-muted-small">em "{{ resumoEntrada.descricaoLocalizacao }}"</span>
        </div>
        <div class="col-6 col-md-3">
          <small class="d-block">Quantidade da OP</small>
          <span class="text-bold">{{ ordem.quantidade | abnt:'quantidade':(ordem.isUnidadeMedidaFracionada ? undefined : 0) }} {{
            ordem.unidade }}</span>
          @if (ordem.quantidadeEntrada === ordem.quantidade) {
          <span class="d-block text-muted-small">lançada sem diferença</span>
          }
        </div>
        @if (ordem.quantidadeEntrada !== ordem.quantidade) {
        <div class="col-6 col-md-3">
          <small class="d-block">Diferença no lançamento</small>
          <span class="status-badge" [class.badge-verde]="ordem.quantidadeEntrada! > ordem.quantidade"
            [class.badge-vermelho]="ordem.quantidadeEntrada! < ordem.quantidade">
            {{ ordem.quantidadeEntrada! > ordem.quantidade ? '+' : '' }}{{ (ordem.quantidadeEntrada! - ordem.quantidade)
            |
            abnt:'quantidade':(ordem.isUnidadeMedidaFracionada ? undefined : 0) }} sobre a OP
          </span>
          @if (ordem.justificativaAjusteEntrada) {
          <span class="d-block text-muted-small">Motivo: {{ ordem.justificativaAjusteEntrada }}</span>
          }
        </div>
        }
        @if (resumoEntrada.codigoLote) {
        <div class="col-6 col-md-3">
          <small class="d-block">Lote</small>
          <span class="text-bold">{{ resumoEntrada.codigoLote }}</span>
          <span class="d-block text-muted-small">
            Fabricação {{ resumoEntrada.dataFabricacaoLote | date:'dd/MM/yyyy' }} ·
            validade {{ resumoEntrada.dataValidadeLote | date:'dd/MM/yyyy' }}
          </span>
        </div>
        }
        @if (resumoEntrada.codigosSerie.length > 0) {
        <div class="col-12 col-md-6">
          <small class="d-block">Números de série</small>
          <div class="chips-tags">
            @for (serie of resumoEntrada.codigosSerie; track serie) {
            <span class="status-badge badge-cinza">{{ serie }}</span>
            }
          </div>
        </div>
        }
      </div>

      @if (resumoInsumos.length > 0) {
      <div class="baixa-materia-prima">
        <button type="button" class="baixa-materia-prima__toggle"
          (click)="baixaMateriaPrimaAberta = !baixaMateriaPrimaAberta">
          <span>Baixa de matérias-primas ({{ resumoInsumos.length }})</span>
          <mat-icon class="material-symbols-outlined">{{ baixaMateriaPrimaAberta ? 'expand_less' : 'expand_more'
            }}</mat-icon>
        </button>
        @if (baixaMateriaPrimaAberta) {
        <div class="baixa-materia-prima__grid">
          @for (insumo of resumoInsumos; track insumo.idProduto) {
          <div class="baixa-materia-prima__item">
            <span class="baixa-materia-prima__qtd">−{{ insumo.quantidade | abnt:'quantidade' }} {{ insumo.unidade
              }}</span>
            <span>{{ insumo.nomeProduto }}</span>
            <span class="d-block text-muted-small">{{ insumo.descricaoLocalizacao }}</span>
          </div>
          }
        </div>
        }
      </div>
      }
      }
    </div>
    }

    <!-- ── Grade de informações ────────────────────────────────────────── -->
    <div class="section-container">
      <div class="row g-3">
        <div class="col-6 col-md-3">
          <small class="d-block">Produto a ser produzido</small>
          <span class="text-bold">{{ ordem.nomeProduto }}</span>
          @if (ordem.codigoSku) { <span class="d-block text-muted-small">{{ ordem.codigoSku }}</span> }
        </div>
        <div class="col-6 col-md-3">
          <small class="d-block">Quantidade</small>
          <span class="text-bold">{{ ordem.quantidade | abnt:'quantidade':(ordem.isUnidadeMedidaFracionada ? undefined : 0) }} {{
            ordem.unidade }}</span>
        </div>
        <div class="col-6 col-md-3">
          <small class="d-block">Data início</small>
          <span class="text-bold">{{ ordem.dataInicio | date: 'dd/MM/yyyy' }}</span>
        </div>
        <div class="col-6 col-md-3">
          <small class="d-block">Data prevista de término</small>
          <span class="text-bold">{{ ordem.dataPrevistaTermino ? (ordem.dataPrevistaTermino | date: 'dd/MM/yyyy') : '--'
            }}</span>
        </div>
        <div class="col-6 col-md-3">
          <small class="d-block">Criado por</small>
          <span class="text-bold">{{ ordem.nomeUsuarioInclusao }}</span>
        </div>
        <div class="col-6 col-md-3">
          <small class="d-block">Criado em</small>
          <span class="text-bold">{{ ordem.datetimeInclusao | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="col-6 col-md-3">
          <small class="d-block">Tags</small>
          @if (ordem.tags.length > 0) {
          <div class="chips-tags">
            @for (tag of ordem.tags; track tag.idTagProducao) {
            <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
            }
          </div>
          } @else {
          <p class="texto-vazio">Nenhuma tag adicionada.</p>
          }
        </div>
        @if (ordem.idOrdemProducaoPai) {
        <div class="col-6 col-md-3">
          <small class="d-block">Ordem de origem</small>
          <span class="text-bold">OP {{ ordem.numeroOrdemProducaoPai }}</span>
        </div>
        }
      </div>
    </div>

    <!-- ── Composição ───────────────────────────────────────────────────── -->
    <div class="section-container">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
        <span>Composição</span>
      </div>

      @if (ordem.itens.length > 0) {
      <div class="table-responsive desktop-view">
        <table mat-table [dataSource]="ordem.itens">
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef>Matéria-prima</th>
            <td mat-cell *matCellDef="let item">{{ item.nomeProduto }}</td>
          </ng-container>

          <ng-container matColumnDef="sku">
            <th mat-header-cell *matHeaderCellDef>Código (SKU)</th>
            <td mat-cell *matCellDef="let item" class="text-muted">{{ item.codigoSku }}</td>
          </ng-container>

          <ng-container matColumnDef="quantidadeUnitaria">
            <th mat-header-cell *matHeaderCellDef class="text-end">Qtd. unitária</th>
            <td mat-cell *matCellDef="let item" class="text-end coluna-numerica">
              {{ item.quantidadeUnitaria | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade }}
            </td>
          </ng-container>

          <ng-container matColumnDef="quantidadeTotal">
            <th mat-header-cell *matHeaderCellDef class="text-end">Qtd. total</th>
            <td mat-cell *matCellDef="let item" class="text-end coluna-numerica fw-semibold">
              {{ item.quantidadeTotal | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade }}
            </td>
          </ng-container>

          <ng-container matColumnDef="saldo">
            <th mat-header-cell *matHeaderCellDef class="text-end">Estoque atual</th>
            <td mat-cell *matCellDef="let item" class="text-end coluna-numerica"
              [class.saldo-insuficiente]="item.saldoAtual !== null && item.saldoAtual < item.quantidadeTotal">
              {{ item.saldoAtual | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="colunasComposicao"></tr>
          <tr mat-row *matRowDef="let row; columns: colunasComposicao"></tr>
        </table>
      </div>

      <div class="mobile-view">
        @for (item of ordem.itens; track item.idProduto) {
        <div class="item-card">
          <div class="item-card__header">
            <div class="item-card__produto">
              <strong>{{ item.nomeProduto }}</strong>
              @if (item.codigoSku) { <span class="item-card__sku">SKU: {{ item.codigoSku }}</span> }
            </div>
          </div>
          <div class="item-card__body">
            <div class="item-card__grid">
              <div>
                <span class="item-card__label">Qtd. unitária</span>
                <span>{{ item.quantidadeUnitaria | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{
                  item.unidade
                  }}</span>
              </div>
              <div>
                <span class="item-card__label">Qtd. total</span>
                <span class="fw-semibold">{{ item.quantidadeTotal | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined :
                  0) }}
                  {{ item.unidade }}</span>
              </div>
              <div>
                <span class="item-card__label">Estoque atual</span>
                <span [class.saldo-insuficiente]="item.saldoAtual !== null && item.saldoAtual < item.quantidadeTotal">
                  {{ item.saldoAtual | abnt:'quantidade':(item.isUnidadeMedidaFracionada ? undefined : 0) }} {{ item.unidade }}
                </span>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      } @else {
      <p class="texto-vazio">Esta ordem não tem composição registrada.</p>
      }
    </div>

    <!-- ── Etapas ───────────────────────────────────────────────────────── -->
    <div class="section-container">
      <div class="section-title">
        <mat-icon class="material-symbols-outlined">checklist</mat-icon>
        <span>Etapas da Produção</span>
      </div>

      @if (totalEtapas > 0) {
      <div class="progresso-etapas">
        <div class="progresso-etapas__cabecalho">
          <span class="progresso-texto">{{ etapasConcluidas }} de {{ totalEtapas }} etapas concluídas</span>
          <span class="progresso-percentual">{{ progressoEtapas | number: '1.0-0' }}%</span>
        </div>
        <mat-progress-bar mode="determinate" [value]="progressoEtapas"></mat-progress-bar>
      </div>

      <div class="etapa-card">
        <ol class="etapa-timeline">
          @for (etapa of ordem.etapas; track etapa.idOrdemProducaoEtapa) {
          <li class="etapa-timeline-item">
            <div class="etapa-no"
              [class.etapa-no-concluida]="etapa.idStatusEtapaOrdemProducao === statusEtapaOrdemProducaoEnum.Concluida"
              [class.etapa-no-andamento]="etapa.idStatusEtapaOrdemProducao === statusEtapaOrdemProducaoEnum.EmAndamento">
              @if (etapa.idStatusEtapaOrdemProducao === statusEtapaOrdemProducaoEnum.Concluida) {
              <mat-icon class="material-symbols-outlined">check</mat-icon>
              } @else {
              <span>{{ etapa.ordem }}</span>
              }
            </div>

            <div class="etapa-corpo">
              <div class="etapa-info">
                <strong>{{ etapa.descricao }}</strong>

                <div class="etapa-meta">
                  <span class="etapa-meta-item">
                    <mat-icon class="material-symbols-outlined">play_circle</mat-icon>
                    {{ etapa.datetimeInicio ? (etapa.datetimeInicio | date: 'dd/MM/yyyy HH:mm') : '--' }}
                  </span>
                  <span class="etapa-meta-item">
                    <mat-icon class="material-symbols-outlined">stop_circle</mat-icon>
                    {{ etapa.datetimeFim ? (etapa.datetimeFim | date: 'dd/MM/yyyy HH:mm') : '--' }}
                  </span>
                  @if (etapa.nomeUsuarioResponsavel) {
                  <span class="etapa-meta-item">
                    <mat-icon class="material-symbols-outlined">person</mat-icon>
                    {{ etapa.nomeUsuarioResponsavel }}
                  </span>
                  }
                  @if (duracaoEtapa(etapa)) {
                  <span class="etapa-meta-item etapa-duracao">
                    <mat-icon class="material-symbols-outlined">timer</mat-icon>
                    {{ duracaoEtapa(etapa) }}
                  </span>
                  }
                </div>
              </div>

              <div class="etapa-lado-direito">
                <span class="status-badge"
                  [ngClass]="statusEtapaOrdemProducaoBadge[etapa.idStatusEtapaOrdemProducao]">
                  {{ statusEtapaOrdemProducaoDescricao[etapa.idStatusEtapaOrdemProducao] }}
                </span>

                @if (etapaEmAcao.has(etapa.idOrdemProducaoEtapa)) {
                <mat-spinner diameter="20"></mat-spinner>
                } @else {
                @if (podeIniciar(etapa)) {
                <span [matTooltip]="isTravadaPorEstoque ? 'Exclua o estoque para iniciar etapas' : ''">
                  <button mat-stroked-button class="btn-secondary" [disabled]="isTravadaPorEstoque"
                    (click)="iniciarEtapa(etapa)">
                    <mat-icon class="material-symbols-outlined">play_arrow</mat-icon> Iniciar
                  </button>
                </span>
                }
                @if (podeConcluir(etapa)) {
                <span [matTooltip]="isTravadaPorEstoque ? 'Exclua o estoque para concluir etapas' : ''">
                  <button mat-flat-button class="btn-primary" [disabled]="isTravadaPorEstoque"
                    (click)="concluirEtapa(etapa)">
                    <mat-icon class="material-symbols-outlined">check</mat-icon> Concluir
                  </button>
                </span>
                }
                @if (etapaBloqueada(etapa)) {
                <span class="etapa-cadeado" matTooltip="Conclua a etapa anterior antes de iniciar esta">
                  <mat-icon class="material-symbols-outlined">lock</mat-icon>
                </span>
                }
                @if (podeAjustarTempos()) {
                <span [matTooltip]="isTravadaPorEstoque ? 'Exclua o estoque para ajustar os tempos' : 'Ajustar tempos manualmente'">
                  <button mat-icon-button [disabled]="isTravadaPorEstoque" (click)="abrirAjustarTempos(etapa)"
                    class="btn-editar-datas" aria-label="Ajustar tempos manualmente">
                    <mat-icon class="material-symbols-outlined">edit_calendar</mat-icon>
                  </button>
                </span>
                }
                }
              </div>
            </div>
          </li>
          }
        </ol>
      </div>
      } @else {
      <p class="texto-vazio">Nenhuma etapa cadastrada.</p>
      }
    </div>

    <!-- ── Observações e Histórico ───────────────────────────────────────────── -->
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="section-container">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">notes</mat-icon>
            <span>Observações</span>
          </div>
          @if (ordem.observacoes) {
          <p class="texto-observacoes">{{ ordem.observacoes }}</p>
          } @else {
          <p class="texto-vazio">Nenhuma observação registrada.</p>
          }
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="section-container">
          <div class="section-title">
            <mat-icon class="material-symbols-outlined">history</mat-icon>
            <span>Histórico</span>
          </div>

          @if (_isLoadingHistorico) {
          <app-loading-box [height]="'56'"></app-loading-box>
          <app-loading-box [height]="'56'" [margin]="'12px 0 0 0'"></app-loading-box>
          <app-loading-box [height]="'56'" [margin]="'12px 0 0 0'"></app-loading-box>
          } @else {
          <app-timeline-historico [itens]="itensHistorico" [exibirFiltros]="true" [permiteAnotacao]="podeAlterar"
            [registrandoAnotacao]="isRegistrandoAnotacao"
            (registrarAnotacao)="registrarAnotacao($event)"></app-timeline-historico>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>